module.exports = __webpack_public_path__ + "img/banner4.b351f91c.png";